import { useTranslate } from "@tolgee/react";
import { useAtom } from "jotai";
import { cn } from "#/lib/utils";
import {
	twapDurationAtom,
	twapNumSlicesAtom,
} from "./stores/order-form-atoms.ts";
import { sanitizeNumericInput } from "./utils/sanitize-numeric-input.ts";

const TWAP_MAX_DECIMALS = 0;

const fieldClass =
	"flex items-center gap-1.5 rounded-[8px] border border-trade-border-subtle bg-trade-surface-inset px-2.5 py-1.5 sm:gap-2 sm:rounded-[10px] sm:px-3.5 sm:py-2";

const inputClass =
	"w-full bg-transparent text-label1-bold text-trade-text outline-none placeholder:text-trade-text-faint sm:text-body2-bold";

const labelClass = "whitespace-nowrap text-label2 sm:text-body2";

export function TwapFields() {
	const { t } = useTranslate();
	const [twapDuration, setTwapDuration] = useAtom(twapDurationAtom);
	const [twapNumSlices, setTwapNumSlices] = useAtom(twapNumSlicesAtom);

	return (
		<div className="flex items-center gap-x-1.5 sm:gap-x-2">
			<label className={cn("flex-1", fieldClass)}>
				<div className="flex items-center justify-between gap-2 text-caption1-medium text-trade-text-secondary sm:gap-3 sm:text-label2-medium">
					<p className={labelClass}>{t("form.duration")}</p>
					<input
						type="text"
						inputMode="numeric"
						className={inputClass}
						value={twapDuration}
						onChange={(e) =>
							setTwapDuration(
								sanitizeNumericInput(e.target.value, TWAP_MAX_DECIMALS),
							)
						}
						placeholder="30"
					/>
					<p className={labelClass}>{t("form.duration-unit")}</p>
				</div>
			</label>
			<label className={cn("flex-1", fieldClass)}>
				<div className="flex items-center justify-between gap-2 text-caption1-medium text-trade-text-secondary sm:gap-3 sm:text-label2-medium">
					<p className={labelClass}>{t("form.slices")}</p>
					<input
						type="text"
						inputMode="numeric"
						className={inputClass}
						value={twapNumSlices}
						onChange={(e) =>
							setTwapNumSlices(
								sanitizeNumericInput(e.target.value, TWAP_MAX_DECIMALS),
							)
						}
						placeholder="10"
					/>
				</div>
			</label>
		</div>
	);
}
